import React, { useState, useEffect } from "react";
import Extrato from '../../components/data/Extrato'
import useAxios from "../../helpers/useAxios";
import Collapse from 'react-bootstrap/Collapse';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import { subtractYearsDate, subtractDaysDate, getCurrentDate, formatDateStandart, formatDateService } from "../../helpers/utils.js";
import { pt } from "date-fns/locale";
import 'react-datepicker/dist/react-datepicker.css';

const FundosConsolidado = (props) => {
  const [showType, setShowType] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [valAssoc, setValAssoc] = useState();
  const [valPart, setValPart] = useState();
  const [valTotal, setValTotal] = useState();
  const [isLoaded, setIsLoaded] = useState(false);

  const { fetch, data, error, loaded } = useAxios("POST", "/Funds/consolidated-extract", {
    nif: props.nif,
    initialDate: formatDateService(startDate),
    endDate: formatDateService(endDate),
  });

  useEffect(() => {
    if (loaded && error.length === 0)
    {
      setIsLoaded(true);

      setValAssoc(data.valorAssoc);
      setValPart(data.valorPartic);
      setValTotal(data.valorTotal);
    }
  }, [data]);

  function imgToBase64(url, callback) {
    if (!window.FileReader) {
      callback(null);
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    
    xhr.onload = function() {
      var reader = new FileReader();
      
      reader.onloadend = function() {
        callback(reader.result.replace('text/xml', 'image/jpeg'));
      };
      
      reader.readAsDataURL(xhr.response);
    };

    xhr.open('GET', url);
    xhr.send();
  }

  var base64Img;
  imgToBase64("./email-header.png", function(base64) {
    base64Img = base64;
  });

  const downloadData = (funds, type) => {
    var rowsFundsPdf = Object.values(funds).map(f => [f.idFundo, f.nome]);

    const doc = new jsPDF({
      orientation: 'portrait',
      format: 'a4',
			unit: 'px',
		});

    var totalPagesExp = '{total_pages_count_string}';

    for(var i = 0; i <= rowsFundsPdf.length - 1; i++)
    {
      var rowsPdf = Object.values(funds[i].moviments).map(m => [m.data, m.movimento, m.cotacao, m.unidadesAssoc, m.unidadesPart, m.unidadesTotal, m.montanteAssoc, m.montantePart, m.montanteTotal]);
      var rowsPdfByType = [];

      if(type === 1) {
        if(rowsPdf[0][1] === 'Saldo Final') {
          rowsPdfByType.push(rowsPdf[0]);
        }

        if(rowsPdf[rowsPdf.length - 1][1] === 'Saldo Anterior') {
          rowsPdfByType.push(rowsPdf[rowsPdf.length - 1]);
        }
      }
      else {
        rowsPdfByType = rowsPdf;
      }

      autoTable(doc, {
        head: [
        [
          { content: rowsFundsPdf[i][1], colSpan: 9, styles: {fontSize: 12, fontStyle: 'normal', fillColor: [255, 255, 255], textColor: [0, 0, 0]} },
        ],
        [
          { content: 'Data', rowSpan: 2, styles: {fillColor: [0, 113, 206]} },
          { content: 'Operação', rowSpan: 2, styles: {fillColor: [0, 113, 206]} },
          { content: 'Cotação', rowSpan: 2, styles: {halign: 'right', fillColor: [0, 113, 206]} },
          { content: 'N.º unidades participação (UPs)', colSpan: 3, styles: {halign: 'center', fillColor: [0, 62, 113]}},
          { content: 'Montante (EUR)', colSpan: 3, styles: {halign: 'center', fillColor: [0, 113, 206]} }
        ],
        [
          { content: 'Associado', styles: {halign: 'center', fontSize: 9, fillColor: [0, 62, 113]} },
          { content: 'Participante', styles: {halign: 'center', fontSize: 9, fillColor: [0, 62, 113]} },
          { content: 'Total', styles: {halign: 'center', fontSize: 9, fillColor: [0, 62, 113]} },
          { content: 'Associado', styles: {halign: 'center', fontSize: 9, fillColor: [0, 113, 206]} },
          { content: 'Participante', styles: {halign: 'center', fontSize: 9, fillColor: [0, 113, 206]} },
          { content: 'Total', styles: {halign: 'center', fontSize: 9, fillColor: [0, 113, 206]} },
        ]], 
        body: rowsPdfByType,
  
        margin: [40, 15, 110, 15], // [top, right, down, left]
        columnStyles: { 2: { halign: 'right' }, 3: { halign: 'right' }, 4: { halign: 'right' }, 5: { halign: 'right' }, 6: { halign: 'right' }, 7: { halign: 'right' }, 8: { halign: 'right' } },
  
        didParseCell: function (data) {
          var rowsCount = data.table.body.length;
  
          if(data.row.section === 'body') {
            if (data.row.index === 0) {
              data.cell.styles.fontStyle = 'bold';
            }

            if (data.row.index === rowsCount - 1 && data.row.raw[1] === 'Saldo Anterior') {
              data.cell.styles.fontStyle = 'bold';
            }
          }
        },
        
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(13);
          doc.setTextColor("#000000")
  
          if (base64Img) { 
            doc.addImage(base64Img, 'PNG', 200, 15, 30, 25);
          }   
          
          // Footer 
          var footerText = 'Página ' + doc.internal.getNumberOfPages();
          
          // Total page number plugin only available in jspdf v1.0+ 
          if (typeof doc.putTotalPages === 'function') { 
            footerText = footerText + ' de ' + totalPagesExp;
          } 
    
          // jsPDF 1.4+ uses getWidth, <1.4 uses .width 
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          
          doc.setFontSize(7);
          doc.setTextColor('#666666');
          doc.text("O valor da unidade de participação (UP) dos Fundos de Pensões evolui, em cada momento, em função do valor dos ativos integrantes da carteira do Fundo, pelo que pode aumentar ou diminuir, sendo o respetivo valor divulgado diariamente, nos dias úteis.", 15, pageHeight - 100, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
          doc.text("Os valores apresentados foram calculados com base nas UP diárias do Fundo, que refletem o potencial de valorização dos ativos subjacentes e o valor atual dos rendimentos futuros.", 15, pageHeight - 86, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
          doc.text("O valor da UP é líquido de comissões e impostos na esfera do Fundo, estando o investidor sujeito à aplicação das comissões contratualizadas, nomeadamente comissão de reembolso ou de subscrição caso tal se aplique, bem como à fiscalidade inerente a este produto a título de imposto sobre os rendimentos das pessoas singulares.", 15, pageHeight - 72, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
          doc.text("Os Fundos de Pensões encontram-se isentos de imposto sobre o rendimento, exceto na situação prevista no n.º11 do art.º 88.º do Código do IRC. Por regra, os participantes são tributados no momento do reembolso, por retenção na fonte.", 15, pageHeight - 58, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
          doc.text("Os Documentos Constitutivos dos Fundos de Pensões encontram-se disponíveis em na área: Extrato Individual > Informação sobre o Fundo.", 15, pageHeight - 44, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
          doc.text("Caso cesse o vínculo laboral, o valor associado aos direitos adquiridos poderá diferir do apresentado, de acordo com as regras do plano de Pensões.", 15, pageHeight - 37, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
          doc.text("Os valores apresentados são referentes à situação financeira específica do Participante.", 15, pageHeight - 30, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
          doc.text("A CGD PENSÕES, Sociedade Gestora de Fundos de Pensões, S.A., não é responsável pela realização das contribuições a cargo do Associado.", 15, pageHeight - 23, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
  
          doc.setFontSize(9);
          doc.setTextColor("#000000")
          doc.text(footerText, 500, pageHeight - 10, 'right');
        }
      });
    }

    // Total page number plugin only available in jspdf v1.0+ 
    if (typeof doc.putTotalPages === 'function') { 
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('extratoconsolidado_' + getCurrentDate('-') + '.pdf');
  }

  return (
    <div className="col-md-12 bg-white rounded-4 p-3 mb-4">
      <div className="row">
        <div className="col-6 my-auto">
          <h3 className="my-auto">Período de {formatDateStandart(startDate === undefined ? subtractYearsDate(new Date(), 5) : startDate)} a {formatDateStandart(endDate === undefined ? subtractDaysDate(new Date(), 1) : endDate)}</h3>
        </div>
        <div className="col-6 text-end">
          <button type="button" className="btn btn-table me-3"
            onClick={() => setIsOpen(!isOpen)}
            >
              <div className="row">
                <div className="col-4">
                  <svg width="16px" height="16px" viewBox="0 0 1024 1024" className="me-1">
                    <g stroke="none" strokeWidth="1" fill="#3F5B78" fillRule="evenodd">
                      <path d="M554.666667 512a42.666667 42.666667 0 0 1 8.533333-25.6l256-341.333333a42.666667 42.666667 0 1 1 68.266667 51.2L640 526.208V768a42.666667 42.666667 0 0 1-23.594667 38.144l-170.666666 85.333333A42.666667 42.666667 0 0 1 384 853.333333v-327.125333L136.533333 196.266667A42.666667 42.666667 0 0 1 170.666667 128h512a42.666667 42.666667 0 0 1 0 85.333333H256l204.8 273.066667a42.666667 42.666667 0 0 1 8.533333 25.6v272.298667l85.333334-42.666667V512z" />
                    </g>
                  </svg>
                </div>
                <div className="col-8 ps-0" style={{marginTop:'2px'}}>Filtrar</div>
              </div>
          </button>
          <button type="button" className="btn btn-table"
            onClick={() => downloadData(data.funds, showType)}
            >
              <svg width="16px" height="16px" viewBox="0 0 1024 1024">
                <g stroke="none" strokeWidth="1" fill="#3F5B78" fillRule="evenodd">
                  <path d="M896 928c0 17.664-14.336 32-32 32l-704 0C142.336 960 128 945.664 128 928l0 0C128 910.336 142.336 896 160 896l704 0C881.664 896 896 910.336 896 928L896 928zM479.104 96.896l0 558.976-153.6-153.664c-12.8-12.8-33.6-12.8-46.464 0s-12.8 33.6 0 46.464l209.664 209.728c0.64 0.64 1.408 0.832 2.048 1.344 2.624 2.304 5.376 4.416 8.64 5.76 3.648 1.408 7.36 2.112 11.2 2.24C511.104 767.68 511.488 768 512 768c0.768 0 1.344-0.448 2.048-0.448 3.584-0.192 7.04-0.768 10.496-2.048 3.84-1.6 7.232-3.968 10.176-6.784 0 0 0.32-0.192 0.512-0.32l209.664-209.728c6.4-6.4 9.6-14.784 9.6-23.168 0-8.448-3.264-16.832-9.6-23.232-12.864-12.8-33.6-12.8-46.464 0l-153.664 153.664 0.32-558.976C545.152 78.72 530.432 64 512.32 64S479.104 78.72 479.104 96.896z" />
                </g>
              </svg>
          </button>
        </div>
      </div>
      <Collapse in={isOpen}>
        <div className="mt-4">
          <div className="row">
            <div className="form-group col-4">
              <label>Data de início</label>
              <DatePicker className="form-control" selected={startDate} dateFormat="dd/MM/yyyy" locale={pt} showYearDropdown minDate={new Date(2000, 0, 1)} maxDate={subtractDaysDate(new Date(), 1)} onChange={(date) => {
                  setStartDate(date);
                  //setEndDate(date);
                }} />
            </div>
            <div className="form-group col-4">
              <label>Data de fim</label>
              <DatePicker className="form-control" selected={endDate} dateFormat="dd/MM/yyyy" locale={pt} showYearDropdown minDate={startDate} maxDate={subtractDaysDate(new Date(), 1)} onChange={(date) => {
                  setEndDate(date);
                }} />
            </div>
          </div>
          <div className="row pt-4">
            <div className="col-12">
              <button type="submit" className="btn btn-primary btn-small me-3"
                onClick={() => {
                  setIsLoaded(false);

                  fetch("POST", "/Funds/consolidated-extract", {
                    nif: props.nif,
                    initialDate: formatDateService(startDate),
                    endDate: formatDateService(endDate),
                  });
                }}>
                Mostrar resultados
              </button>
            </div>
          </div>
        </div>
      </Collapse>
      {!isLoaded && (
        <div className="text-center pt-4">
          <div className="spinner-border text-blue" role="status">
          </div>
        </div>
       )}
        {(isLoaded && error.length === 0) && (
          <div>
          <div className="row mt-5">
          <div className="col-md-9 my-auto">
            <h3 className="my-auto">Montante acumulado</h3>
            <div className="row mt-3">
              <div className="col-md-4">
                <p className="fw-bold mb-1" style={{color:'#3F5B78'}}>Associado</p>
                <p style={{fontSize:'20px'}}>{valAssoc} EUR</p>
              </div>
              <div className="col-md-4">
                <p className="fw-bold mb-1" style={{color:'#3F5B78'}}>Participante</p>
                <p style={{fontSize:'20px'}}>{valPart} EUR</p>
              </div>
              <div className="col-md-4">
                <p className="fw-bold mb-1" style={{color:'#3F5B78'}}>Total</p>
                <p style={{fontSize:'20px'}}>{valTotal} EUR</p>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-end">
          <button
                type="button" className={"btn btn-graph btn-graph-first " + (showType === 1 ? 'btn-graph-active' : '')}
                onClick={() => setShowType(1)}
              >
                Resumo
              </button>
          <button
                type="button" className={"btn btn-graph btn-graph-last " + (showType === 2 ? 'btn-graph-active' : '')}
                onClick={() => setShowType(2)}
              >
                Movimentos
              </button>
          </div>
          </div>
          <Extrato rows={data.funds} type={showType} />
          </div>
        )}
    </div>
  );
};

export default FundosConsolidado;